import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import {
  LoadOrganizationReports,
  SetOrganizationReports,
  SetOrganizationReportsError,
} from './analytics.actions';
import { AnalyticsService } from './analytics.service';
import { OrganizationReports } from 'src/app/admin/models/analytics.model';

@Injectable()
export class AnalyticsEffects {
  loadOrganizationReports$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadOrganizationReports),
      mergeMap((action) =>
        this.analyticsService.getOrganizationReports(action.payload).pipe(
          map((organizationReports: OrganizationReports) =>
            SetOrganizationReports({ organizationReports }),
          ),
          catchError((error) => of(SetOrganizationReportsError({ error }))),
        ),
      ),
    ),
  );

  constructor(private actions$: Actions, private analyticsService: AnalyticsService) {}
}
